module.exports = __webpack_public_path__ + "img/list-simulations.2cc2ad49.png";